import React, { createContext, useContext, FC } from 'react';
import defineAbilitiesFor from '../utils/ability';

interface AbilityProviderProps {
  role: string;
  permissions: any[];
  children: any;
}

export const AbilityContext = createContext<any>(null);

export const AbilityProvider: FC<AbilityProviderProps> = ({
  children,
  role,
  permissions,
}) => {
  const ability = defineAbilitiesFor(role, permissions);

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};

export const useAbility = () => {
  const ability = useContext(AbilityContext);
  if (!ability) {
    throw new Error('useAbility must be used within an AbilityProvider');
  }
  return ability;
};
